/**
 * Curated emoji for source and container icons. Deliberately small and
 * hand-picked rather than a full emoji dataset: the field's free-text tab is
 * the escape hatch for anything not here, so shipping a picker library (and
 * its dataset) into the admin bundle would buy very little.
 */
export const ICON_EMOJI: readonly string[] = [
  // Books and reading
  '📚',
  '📖',
  '📗',
  '📘',
  '📙',
  '📕',
  '📓',
  '📔',
  '📒',
  '📑',
  '🔖',
  '🏷️',
  // Containers and organization
  '🗂️',
  '📁',
  '📂',
  '🗃️',
  '🗄️',
  '🧭',
  '🗺️',
  // Writing and notes
  '📝',
  '✏️',
  '🖊️',
  '🗒️',
  // Thinking and practice
  '🧠',
  '💡',
  '🔬',
  '🧪',
  '🧮',
  '🎯',
  '🧩',
  // Engineering
  '⚙️',
  '🛠️',
  '🔧',
  '🧰',
  '💻',
  '🖥️',
  '⌨️',
  '🖱️',
  '🌳',
  '🕸️',
  '🧵',
  '🔢',
  // Teaching and interviews
  '🎓',
  '🏫',
  '👩‍💻',
  '👨‍🏫',
  '🗣️',
  '💬',
  '🎤',
  '🎧',
  '🎥',
  '📺',
  '📡',
  // Progress and time
  '⏱️',
  '⏳',
  '📈',
  '📉',
  '📊',
  '🚀',
  '🏁',
  '🏆',
  '🥇',
  '⭐',
  '🔥',
  '✅',
  '❓',
  '❗',
]
